import React from "react";
import { CreateOutlined } from "@material-ui/icons";
import { Button } from "@my-scoot/component-library-legacy";
import { useExitIntentSettingsModal } from "../EditExitIntentForm/modules/ContactFormSettings/utils/useExitIntentSettingsModal";
import { ExitIntentFormSettings } from "../EditExitIntentForm/modules/ContactFormSettings/ExitIntentFormSettings";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import { LazyLoadWrapper } from "features/Common/LazyLoadWrapper/LazyLoadWrapper";

export const ExitIntentSettingsButton = withComponentLibraryTheme(() => {
  const { openExitIntentSettingsModal, isExitIntentSettingsModalOpen } =
    useExitIntentSettingsModal();
  return (
    <div className="tw-flex tw-items-center tw-gap-[10px]">
      <Button
        color="secondary"
        variant="outlined"
        size="small"
        onClick={openExitIntentSettingsModal}
        className="tw-h-[32px] tw-text-[14px]"
      >
        <CreateOutlined className="tw-w-[18px] tw-h-[18px] tw-mr-1.5" />
        Manage Form
      </Button>

      <LazyLoadWrapper loadingCondition={isExitIntentSettingsModalOpen}>
        <ExitIntentFormSettings />
      </LazyLoadWrapper>
    </div>
  );
});
